import { render, staticRenderFns } from "./locations.vue?vue&type=template&id=5d1bcf50&"
import script from "./locations.vue?vue&type=script&lang=js&"
export * from "./locations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports